export const deleteDocument = (payload?: any) => ({
    type: "@saga/DELETE_DOCUMENT",
    payload
});

